import { autoinject, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@autoinject()
@transient()
export class PipelineErrorLogsDialog {

    public process: any;

    constructor(protected dialogClientService: DialogClientService) { }

    activate(model: { process: any }) {
        this.process = model.process;
    }

    cancel() {
        this.dialogClientService.hide();
    }

}